import { d as dayjs, D as DatePicker } from './index-f0eabfa6.js';
import React__default from 'react';
import Box from './Box.js';
import TimePicker from './TimePicker.js';
import './darken-303c3324.js';
import './_commonjsHelpers-357b3b4e.js';
import './useTheme.js';
import 'styled-components';
import './Typography.js';
import './LoadingIndicator.js';
import './core.esm-901288dd.js';
import './inheritsLoose-6f2ea841.js';
import './IconTooltip.js';
import './Icon.js';
import './global-2e5d81b9.js';
import './styled-722a6242.js';
import './index-a67b9a05.js';
import './getThemeProps-582952b7.js';
import './useTheme-3df06c17.js';
import './useThemeProps-624634df.js';
import './generateUtilityClasses-06dec860.js';
import './Popper-538498ba.js';
import './useSlotProps-263f7ba4.js';
import './Portal-4e916b93.js';
import 'react-dom';
import './useEnhancedEffect-22d6b63a.js';
import './exactProp-86bc0113.js';
import './refType-6972e729.js';
import './useId-748eec35.js';
import './TransitionGroupContext-42c2fd98.js';
import './useIsFocusVisible-b9c63ec9.js';
import './utils-c09c4ec9.js';
import './objectWithoutPropertiesLoose-6737dabb.js';
import './index-5fd269e1.js';
import './index-48edd52c.js';
import './createTimePickerOptions.js';

const DateTimePicker = ({
  datePickerProps,
  onSelect,
  selectedDate,
  testID,
  timePickerProps
}) => {
  const enhancedSelectedDate = dayjs(selectedDate);
  const handleSelectTimePickerOption = nextSelectedDateTime => {
    const currentDay = enhancedSelectedDate.day();
    const currentMonth = enhancedSelectedDate.month();
    const currentYear = enhancedSelectedDate.year();
    const nextDate = dayjs(nextSelectedDateTime).day(currentDay).month(currentMonth).year(currentYear).toDate();
    onSelect(nextDate, 'time-picker');
  };
  const handleSelectDate = nextSelectedDate => {
    const currentHour = enhancedSelectedDate.hour();
    const currentMinute = enhancedSelectedDate.minute();
    const currentSecond = enhancedSelectedDate.second();
    const nextDate = dayjs(nextSelectedDate).hour(currentHour).minute(currentMinute).second(currentSecond).toDate();
    onSelect(nextDate, 'date-picker');
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    cursor: "default",
    display: "flex",
    flexDirection: "row",
    testID: testID
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    flex: 1
  }, /*#__PURE__*/React__default.createElement(DatePicker, {
    disabledDays: datePickerProps.disabledDays,
    fromMonth: datePickerProps.fromMonth,
    initialMonth: datePickerProps.initialMonth,
    onSelect: handleSelectDate,
    selectedDays: [selectedDate],
    toMonth: datePickerProps.toMonth
  })), /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    flex: 1
  }, /*#__PURE__*/React__default.createElement(TimePicker, {
    loading: timePickerProps.loading,
    loadingTestID: timePickerProps.loadingTestID,
    onSelect: handleSelectTimePickerOption,
    options: timePickerProps.options,
    renderEmptyState: timePickerProps.renderEmptyState,
    selectedItemTestID: timePickerProps.selectedItemTestID,
    selectedTime: selectedDate,
    testID: timePickerProps.testID,
    titleText: timePickerProps.titleText,
    tooltip: timePickerProps.tooltip
  })));
};

export { DateTimePicker as default };
//# sourceMappingURL=DateTimePicker.js.map
